<template>
<div class="hp_covid_widget" style="min-height: 300px;" >
    <div class="red_header">
        <span>
            <a :href="activeWidget == 'world_table' ? landing_page_url : landing_page_url_usa" target="_top">
                <span class="above_phone_portrait">Novel </span>Coronavirus (COVID-19) Fatalities</a>:</span>
        <span class="right">
            <span class="header-table-toggle" :class="{'active' : activeWidget == 'world_table'}" @click="set_active('world_table')" >Global</span>
            <span class="toggle-separator" > | </span>
            <span class="header-table-toggle" :class="{'active' : activeWidget == 'usa_table'}" @click="set_active('usa_table')" ><span class="above_phone_portrait">United States</span><span class="phone_portrait">U.S.</span></span>
        </span>
    </div>
    <div v-show="activeWidget == 'world_table'" class="covid_totals_table" id="covid_totals_table">
        <covid-totals-table 
            :show-header="false" 
            :limit="world_limit" 
            :whitelist="world_whitelist" 
            :blacklist="world_blacklist" 
            :is-iframe="is_iframe"
            ></covid-totals-table>
    </div>
    <div v-show="activeWidget == 'usa_table'" class="covid_totals_table" id="covid_usa_totals_table">
        <covid-usa-totals-table 
            :show-header="false" 
            :limit="usa_limit" 
            :is-iframe="is_iframe" 
            :whitelist="usa_states_whitelist" 
            ></covid-usa-totals-table>
    </div>
</div>
</template>

<script>

const CovidTotalsTable = () => import(/* webpackChunkName: "CovidCovidTotalsTable" */ "./CovidTotalsTable.vue");
const CovidUsaTotalsTable = () => import(/* webpackChunkName: "CovidCovidUsaTotalsTable" */ "./CovidUsaTotalsTable.vue");

import CovidMixin from './CovidMixin.js';

window.covid_table_limit = 10;
window.covid_is_iframe = false;
if( typeof in_iframe_template !== 'undefined' && in_iframe_template === true ){
    covid_is_iframe = in_iframe_template;
    covid_table_limit = 6;
}

export default {
    name: 'covid-hp',
    mixins: [
        CovidMixin,
    ],
    components: {
        'covid-totals-table': CovidTotalsTable,
        'covid-usa-totals-table': CovidUsaTotalsTable,
    },
    props: {
        activeWidget: {
            type: String,
            default: 'world_table',
        },
    },
    data: function(){
        return {
            landing_page_url: '/coronavirus/',
            landing_page_url_usa : '/coronavirus/country/united-states/',
            is_iframe : covid_is_iframe,
            usa_limit: covid_table_limit,
            world_limit: covid_table_limit,
            interval_id : 0,
            world_whitelist: [
                // 'USA', 'Italy', // 'U.S. (No New York)',
                // 'Spain','France',
                // 'UK','Belgium',
                // 'Germany','Netherlands',
                // 'Brazil',
            ],
            world_blacklist: [
                'Iran',
            ],
            usa_states_whitelist: [
                // 'New York', 'New Jersey', 'Michigan',
                // 'Pennsylvania', 'Illinois', 'California',
                // 'Florida', 'Georgia', 'Texas', 'Colorado',
            ],
        };
    },
    created: function(){

        if( this.is_iframe === true ){
            var params = this.get_partners_utm_string();
            this.landing_page_url += '?'+params;
            this.landing_page_url_usa += '?'+params;
        }

        if(this.usa_states_whitelist.length > 0){
            this.usa_limit = this.usa_states_whitelist.length;
        }

        //this.start_interval();

    },
    methods: {

        start_interval : function() {

            this.interval_id = window.setInterval(function() {

                if(this.activeWidget == 'world_table') {
                    this.$set(this, 'activeWidget', 'usa_table');
                } else {
                    this.$set(this, 'activeWidget', 'world_table');
                }

            }.bind(this), 60000); // Every 60 seconds
        },

        set_active : function(str) {

            this.$set(this, 'activeWidget', str);
            // this.activeWidget = str;

            //window.clearInterval(this.interval_id);

            //this.start_interval();
        }
    },
}
</script>

<style lang="scss">
@import "../../vertical/rcp/covid_totals_table.css";
</style>